module.exports = __webpack_public_path__ + "assets/media/invitation-sent.93469170.svg";